(function () {
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var productForm = form.closest('product-form');
      var sectionId = productForm ? productForm.dataset.sectionId : null;
      var checkbox = sectionId
        ? document.querySelector('[data-warranty-checkbox][data-section-id="' + sectionId + '"]')
        : document.querySelector('[data-warranty-checkbox]');
      if (!checkbox || !checkbox.checked || checkbox.dataset.warrantyAdded === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var variantId = checkbox.dataset.variantId;
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      })
        .catch(function () {})
        .then(function () {
          checkbox.dataset.warrantyAdded = 'true';
          if (form.requestSubmit) {
            form.requestSubmit(event.submitter || undefined);
          } else {
            form.submit();
          }
          delete checkbox.dataset.warrantyAdded;
        });
    },
    true
  );
})();
